import React from "react";
import Navigation from "../Navigation/Navigation";
import successfull from "../../assets/t-successfull.png";
import { Link } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useSelector } from "react-redux";

const TransactionSuccessful = () => {
  // Persisted Data
  const ReduxData = useSelector((state) => state.PersistedData);

  // dynamic Description
  const Description = ReduxData.MyProfileSubscription.MySubscriptionPlanName;

  const PlanName = ReduxData.MyProfileSubscription.MySubscriptionPlan;

  return (
    <div>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-3 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/my-profile/subscription">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <div className="successfulPage">
            <img
              loading="lazy"
              src={successfull}
              alt="successfull"
              className="successfull"
            />
            <h2>Congratulations for subscribing to {PlanName} plan!</h2>
            <p>{Description}</p>
            <p>Thank you for choosing CommunityX Digital</p>
            <div className="transaction-buttons">
              <Link to="/my-profile/subscription">
                <button className="view-order-button">Go Back</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionSuccessful;
